import React from 'react'

import clsx from 'clsx'

import BuildConfig from '$extensionSrc/buildConfig'
import ActionButton, {
  ActionButtonIcon,
  ActionButtonSize,
  ActionButtonType,
} from '$extensionSrc/components/ActionButton'
import { loginPath } from '$extensionSrc/consts/urlConsts'

import styles from './LoginAs.module.scss'

export default function LoginAs({
  obfuscatedEmail,
  redirectUrl,
}: {
  obfuscatedEmail: string
  redirectUrl: string
}) {
  const searchParams = new URLSearchParams({ remove_recent_login: '1' })
  const removeRecentLoginURL = `${loginPath}?${searchParams.toString()}`

  return (
    <div className={styles.LoginAs}>
      <div className={styles.formBody}>
        <h2 className="heading2 bold">Log into {BuildConfig.TENANT_NAME} as</h2>
        <ActionButton
          type={ActionButtonType.PRIMARY}
          size={ActionButtonSize.LARGE}
          onClick={() => window.location.assign(redirectUrl)}
          className={styles.loginButton}
          iconName={ActionButtonIcon.GENERAL_OAUTH}
          role="link"
        >
          {obfuscatedEmail}
        </ActionButton>
        <a
          href={removeRecentLoginURL}
          className={clsx('link2', styles.removeLoginLink)}
        >
          Login as a different user
        </a>
      </div>
    </div>
  )
}
